import { defineStore } from 'pinia'
import VLApi from '@/api/VLApi'

//Import other pinia stores
import { useWebportalStore } from './webportal'

//Import models
import { DebtorItem } from '@/models/DebtorItem'

//Setup store
export const useDebtorStore = defineStore('debtor', {
    state: () => ({
        debtors: [] as DebtorItem[],
        selectedDebtorId: null as unknown as number
    }),
    actions: {
        //Get debtors by current logged in user
        async getDebtors() {
            //Do API call and modify state
            try {
                const response = await VLApi.get(`${useWebportalStore().vlApiUrl}/webportal_Principals/getKlanten`);
                this.debtors = response.data.data as DebtorItem[];

                //Set selectedDebtor if there is only one debtor available
                if(this.debtors.length == 1){
                    this.selectedDebtorId = this.debtors[0].id;
                }
            }
            catch (error) {
                console.error(error);
            }
        },
    },
    getters: {
        selectedDebtor: (state) => {
            return state.debtors.find(d => d.id == state.selectedDebtorId);
        }
    }
})